import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminOrganizationsKeys } from 'app/queries/adminOrganizations/adminOrganizationsKeys';
import type { TCall } from './types/TCall';

type TOptionsParams = QueryFunctionContext<ReturnType<typeof adminOrganizationsKeys.options>>;

export const createFetchOrganizationOptionsQueryFn =
  (call: TCall) =>
  ({ signal }: TOptionsParams) =>
    call(() => cancelOnSignal(AdminService.getAllOrganizationsList(), signal));
